import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  VERIFY_2F,
  VERIFY_2F_SUCCESS,
  VERIFY_2F_LOGIN,
  VERIFY_2F_LOGIN_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case VERIFY_2F_LOGIN:
      state = {
        ...state,
        loading: true,
      }
      break
    case VERIFY_2F_LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case VERIFY_2F:
      state = {
        ...state,
        loading: true,
      }
      break
    case VERIFY_2F_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
